import React, { useEffect, useContext }from "react";
import useForm from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { makeStyles } from "@material-ui/core/styles";
import TextField from '@material-ui/core/TextField';
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Check from "@material-ui/icons/Check";

// icons
import PermIdentity from "@material-ui/icons/PermIdentity";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Clearfix from "beaktShared/components/Clearfix/Clearfix.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import "assets/css/expediente.css";
import { SessionContext } from "beaktShared/services/session";

import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
const useStyles = makeStyles(styles);

export default function ExpedienteForm({ addItem, item, handleView, loading }) {
    const { t } = useTranslation(); 
    const session = useContext(SessionContext);
    const classes = useStyles();    
    const { register, handleSubmit, setValue, errors, setError, clearError } = useForm({mode: "onChange"});
    const [ativoCheckbox, setAtivoCheckbox] = React.useState(true);

    const [ativaDomingo,setativaDomingo] = React.useState(false);
    const [ativaSegunda,setativaSegunda] = React.useState(false);
    const [ativaTerca,setativaTerca] = React.useState(false);
    const [ativaQuarta,setativaQuarta] = React.useState(false);
    const [ativaQuinta,setativaQuinta] = React.useState(false);
    const [ativaSexta,setativaSexta] = React.useState(false);
    const [ativaSabado,setativaSabado] = React.useState(false);
    
    const [almocoDomingo,setalmocoDomingo] = React.useState(false);
    const [almocoSegunda,setalmocoSegunda] = React.useState(false);
    const [almocoTerca,setalmocoTerca] = React.useState(false);
    const [almocoQuarta,setalmocoQuarta] = React.useState(false);
    const [almocoQuinta,setalmocoQuinta] = React.useState(false);
    const [almocoSexta,setalmocoSexta] = React.useState(false);
    const [almocoSabado,setalmocoSabado] = React.useState(false);

    const intialValues = {
        id:0,
        descricao:''
    };
   
    useEffect(() => {
        if(!item.expedienteId)
            return;    
        setValue('id', item.expedienteId);     
        setValue('descricao', item.descricao);      
        setAtivoCheckbox(item.ativo);
        
        item.expedienteHorarios.map(item =>{
            if(item.diaSemana===0)//Domingo
            {   
                setativaDomingo(item.ativoDiaSemana);
                setalmocoDomingo(item.ativoAlmoco);
                setValue('ativaDomingo', item.ativoDiaSemana); 
                setValue('almocoDomingo', item.ativoAlmoco);
                setValue('inicioExpedienteDomingo', item.horaInicio);
                setValue('fimExpedienteDomingo', item.horaFim);
                setValue('inicioAlmocoDomingo', item.almocoInicio);
                setValue('fimAlmocoDomingo', item.almocoFim);
            }
            else if(item.diaSemana===1)//Segunda
            {   
                setativaSegunda(item.ativoDiaSemana);
                setalmocoSegunda(item.ativoAlmoco);
                setValue('ativaSegunda', item.ativoDiaSemana); 
                setValue('almocoSegunda', item.ativoAlmoco);
                setValue('inicioExpedienteSegunda', item.horaInicio);
                setValue('fimExpedienteSegunda', item.horaFim);
                setValue('inicioAlmocoSegunda', item.almocoInicio);
                setValue('fimAlmocoSegunda', item.almocoFim);
            }
            else if(item.diaSemana===2)//Terca
            {   
                setativaTerca(item.ativoDiaSemana);
                setalmocoTerca(item.ativoAlmoco);
                setValue('ativaTerca', item.ativoDiaSemana); 
                setValue('almocoTerca', item.ativoAlmoco);
                setValue('inicioExpedienteTerca', item.horaInicio);
                setValue('fimExpedienteTerca', item.horaFim);
                setValue('inicioAlmocoTerca', item.almocoInicio);
                setValue('fimAlmocoTerca', item.almocoFim);
            }
            else if(item.diaSemana===3)//Quarta
            {   
                setativaQuarta(item.ativoDiaSemana);
                setalmocoQuarta(item.ativoAlmoco);
                setValue('ativaQuarta', item.ativoDiaSemana); 
                setValue('almocoQuarta', item.ativoAlmoco);
                setValue('inicioExpedienteQuarta', item.horaInicio);
                setValue('fimExpedienteQuarta', item.horaFim);
                setValue('inicioAlmocoQuarta', item.almocoInicio);
                setValue('fimAlmocoQuarta', item.almocoFim);
            }
            else if(item.diaSemana===4)//Quinta
            {   
                setativaQuinta(item.ativoDiaSemana);
                setalmocoQuinta(item.ativoAlmoco);
                setValue('ativaQuinta', item.ativoDiaSemana); 
                setValue('almocoQuinta', item.ativoAlmoco);
                setValue('inicioExpedienteQuinta', item.horaInicio);
                setValue('fimExpedienteQuinta', item.horaFim);
                setValue('inicioAlmocoQuinta', item.almocoInicio);
                setValue('fimAlmocoQuinta', item.almocoFim);
            }
            else if(item.diaSemana===5)//Sexta
            {   
                setativaSexta(item.ativoDiaSemana);
                setalmocoSexta(item.ativoAlmoco);
                setValue('ativaSexta', item.ativoDiaSemana); 
                setValue('almocoSexta', item.ativoAlmoco);
                setValue('inicioExpedienteSexta', item.horaInicio);
                setValue('fimExpedienteSexta', item.horaFim);
                setValue('inicioAlmocoSexta', item.almocoInicio);
                setValue('fimAlmocoSexta', item.almocoFim);
            }
            else if(item.diaSemana===6)//Sabado
            {   
                setativaSabado(item.ativoDiaSemana);
                setalmocoSabado(item.ativoAlmoco);
                setValue('ativaSabado', item.ativoDiaSemana); 
                setValue('almocoSabado', item.ativoAlmoco);
                setValue('inicioExpedienteSabado', item.horaInicio);
                setValue('fimExpedienteSabado', item.horaFim);
                setValue('inicioAlmocoSabado', item.almocoInicio);
                setValue('fimAlmocoSabado', item.almocoFim);
            }
            return true;
        })
    // eslint-disable-next-line
    }, [item]);

    const buildData = data =>{

        let newdata = 
        {
            expedienteId: parseInt(data.id),
            descricao: data.descricao, 
            usuarioCadastroId:session.id,            
            ativo:ativoCheckbox,
            expedienteHorarios: [
                {
                    diaSemana: 0,//Domingo                    
                    ativoDiaSemana: data.ativaDomingo,
                    ativoAlmoco:data.almocoDomingo,
                    horaInicio: data.ativaDomingo ? data.inicioExpedienteDomingo : null,
                    horaFim: data.ativaDomingo ? data.fimExpedienteDomingo : null,
                    almocoInicio: data.almocoDomingo ? data.inicioAlmocoDomingo : null,
                    almocoFim: data.almocoDomingo ? data.fimAlmocoDomingo : null
                },
                {
                    diaSemana: 1,//Segunda            
                    ativoDiaSemana: data.ativaSegunda,
                    ativoAlmoco:data.almocoSegunda,
                    horaInicio: data.ativaSegunda ? data.inicioExpedienteSegunda : null,
                    horaFim: data.ativaSegunda ? data.fimExpedienteSegunda : null,
                    almocoInicio: data.almocoSegunda ? data.inicioAlmocoSegunda : null,
                    almocoFim: data.almocoSegunda ? data.fimAlmocoSegunda : null
                },
                {
                    diaSemana: 2,//Terca            
                    ativoDiaSemana: data.ativaTerca,
                    ativoAlmoco:data.almocoTerca,
                    horaInicio: data.ativaTerca ? data.inicioExpedienteTerca : null,
                    horaFim: data.ativaTerca ? data.fimExpedienteTerca : null,
                    almocoInicio: data.almocoTerca ? data.inicioAlmocoTerca : null,
                    almocoFim: data.almocoTerca ? data.fimAlmocoTerca : null
                },
                {
                    diaSemana: 3,//Quarta            
                    ativoDiaSemana: data.ativaQuarta,
                    ativoAlmoco:data.almocoQuarta,
                    horaInicio: data.ativaQuarta ? data.inicioExpedienteQuarta : null,
                    horaFim: data.ativaQuarta ? data.fimExpedienteQuarta : null,
                    almocoInicio: data.almocoQuarta ? data.inicioAlmocoQuarta : null,
                    almocoFim: data.almocoQuarta ? data.fimAlmocoQuarta : null
                },
                {
                    diaSemana: 4,//Quinta            
                    ativoDiaSemana: data.ativaQuinta,
                    ativoAlmoco:data.almocoQuinta,
                    horaInicio: data.ativaQuinta ? data.inicioExpedienteQuinta : null,
                    horaFim: data.ativaQuinta ? data.fimExpedienteQuinta : null,
                    almocoInicio: data.almocoQuinta ? data.inicioAlmocoQuinta : null,
                    almocoFim: data.almocoQuinta ? data.fimAlmocoQuinta : null
                },
                {
                    diaSemana: 5,//Sexta            
                    ativoDiaSemana: data.ativaSexta,
                    ativoAlmoco:data.almocoSexta,
                    horaInicio: data.ativaSexta ? data.inicioExpedienteSexta : null,
                    horaFim: data.ativaSexta ? data.fimExpedienteSexta : null,
                    almocoInicio: data.almocoSexta ? data.inicioAlmocoSexta : null,
                    almocoFim: data.almocoSexta ? data.fimAlmocoSexta : null
                },
                {
                    diaSemana: 6,//Sabado            
                    ativoDiaSemana: data.ativaSabado,
                    ativoAlmoco:data.almocoSabado,
                    horaInicio: data.ativaSabado ? data.inicioExpedienteSabado : null,
                    horaFim: data.ativaSabado ? data.fimExpedienteSabado : null,
                    almocoInicio: data.almocoSabado ? data.inicioAlmocoSabado : null,
                    almocoFim: data.almocoSabado ? data.fimAlmocoSabado : null
                }
            ]
        }
        return newdata;
    }

    const validaError = data =>{
        clearError();
        let existerror = false;
        if(data.ativaDomingo)
        {
            if(data.inicioExpedienteDomingo ==="")
            {
                setError("inicioExpedienteDomingo","required");
                existerror = true;
            }   
            if(data.fimExpedienteDomingo ==="")
            {
                setError("fimExpedienteDomingo","required");
                existerror = true;
            }          
        }
        if(data.almocoDomingo)
        {
            if(data.inicioAlmocoDomingo ==="")
            {
                setError("inicioAlmocoDomingo","required");
                existerror = true;
            }   
            if(data.fimAlmocoDomingo ==="")
            {
                setError("fimAlmocoDomingo","required");
                existerror = true;
            }          
        }
        if(data.ativaSegunda)
        {
            if(data.inicioExpedienteSegunda ==="")
            {
                setError("inicioExpedienteSegunda","required");
                existerror = true;
            }   
            if(data.fimExpedienteSegunda ==="")
            {
                setError("fimExpedienteSegunda","required");
                existerror = true;
            }          
        }
        if(data.almocoSegunda)
        {
            if(data.inicioAlmocoSegunda ==="")
            {
                setError("inicioAlmocoSegunda","required");
                existerror = true;
            }   
            if(data.fimAlmocoSegunda ==="")
            {
                setError("fimAlmocoSegunda","required");
                existerror = true;
            }          
        }
        if(data.ativaTerca)
        {
            if(data.inicioExpedienteTerca ==="")
            {
                setError("inicioExpedienteTerca","required");
                existerror = true;
            }   
            if(data.fimExpedienteTerca ==="")
            {
                setError("fimExpedienteTerca","required");
                existerror = true;
            }          
        }
        if(data.almocoTerca)
        {
            if(data.inicioAlmocoTerca ==="")
            {
                setError("inicioAlmocoTerca","required");
                existerror = true;
            }   
            if(data.fimAlmocoTerca==="")
            {
                setError("fimAlmocoTerca","required");
                existerror = true;
            }          
        }
        if(data.ativaQuarta)
        {
            if(data.inicioExpedienteQuarta ==="")
            {
                setError("inicioExpedienteQuarta","required");
                existerror = true;
            }   
            if(data.fimExpedienteQuarta ==="")
            {
                setError("fimExpedienteQuarta","required");
                existerror = true;
            }          
        }
        if(data.almocoQuarta)
        {
            if(data.inicioAlmocoQuarta ==="")
            {
                setError("inicioAlmocoQuarta","required");
                existerror = true;
            }   
            if(data.fimAlmocoQuarta ==="")
            {
                setError("fimAlmocoQuarta","required");
                existerror = true;
            }          
        }
        if(data.ativaQuinta)
        {
            if(data.inicioExpedienteQuinta ==="")
            {
                setError("inicioExpedienteQuinta","required");
                existerror = true;
            }   
            if(data.fimExpedienteQuinta ==="")
            {
                setError("fimExpedienteQuinta","required");
                existerror = true;
            }          
        }
        if(data.almocoQuinta)
        {
            if(data.inicioAlmocoQuinta ==="")
            {
                setError("inicioAlmocoQuinta","required");
                existerror = true;
            }   
            if(data.fimAlmocoQuinta ==="")
            {
                setError("fimAlmocoQuinta","required");
                existerror = true;
            }          
        }
        if(data.ativaSexta)
        {
            if(data.inicioExpedienteSexta ==="")
            {
                setError("inicioExpedienteSexta","required");
                existerror = true;
            }   
            if(data.fimExpedienteSexta ==="")
            {
                setError("fimExpedienteSexta","required");
                existerror = true;
            }          
        }
        if(data.almocoSexta)
        {
            if(data.inicioAlmocoSexta==="")
            {
                setError("inicioAlmocoSexta","required");
                existerror = true;
            }   
            if(data.fimAlmocoSexta ==="")
            {
                setError("fimAlmocoSexta","required");
                existerror = true;
            }          
        }
        if(data.ativaSabado)
        {
            if(data.inicioExpedienteSabado ==="")
            {
                setError("inicioExpedienteSabado","required");
                existerror = true;
            }   
            if(data.fimExpedienteSabado ==="")
            {
                setError("fimExpedienteSabado","required");
                existerror = true;
            }          
        }
        if(data.almocoSabado)
        {
            if(data.inicioAlmocoSabado ==="")
            {
                setError("inicioAlmocoSabado","required");
                existerror = true;
            }   
            if(data.fimAlmocoSabado ==="")
            {
                setError("fimAlmocoSabado","required");
                existerror = true;
            }          
        }
        return existerror;
    }

    const onSubmit = data => {

        let existerror = validaError(data);

        if(existerror)
            return;

        let newdata = buildData(data);        
        addItem(newdata);

    };
    
    const handleViewForm = () => {
        handleView();
    };

    const handleAtiva = (e,diaSemana) =>
    {
        clearError();
        if(diaSemana === 0)//Domingo
        {
            setativaDomingo(e.target.checked);
            if(!e.target.checked)
            { 
                setValue('almocoDomingo', false);
                setValue('inicioExpedienteDomingo', '');
                setValue('fimExpedienteDomingo', '');
                setValue('inicioAlmocoDomingo',  '');
                setValue('fimAlmocoDomingo', '');
            }
        }
        else if(diaSemana === 1)//Segunda
        {
            setativaSegunda(e.target.checked);
            if(!e.target.checked)
            { 
                setValue('almocoSegunda', false);
                setValue('inicioExpedienteSegunda', '');
                setValue('fimExpedienteSegunda', '');
                setValue('inicioAlmocoSegunda',  '');
                setValue('fimAlmocoSegunda', '');
            }
        }
        else if(diaSemana === 2)//Terca
        {
            setativaTerca(e.target.checked);
            if(!e.target.checked)
            { 
                setValue('almocoTerca', false);
                setValue('inicioExpedienteTerca', '');
                setValue('fimExpedienteTerca', '');
                setValue('inicioAlmocoTerca',  '');
                setValue('fimAlmocoTerca', '');
            }
        }
        else if(diaSemana === 3)//Quarta
        {
            setativaQuarta(e.target.checked);
            if(!e.target.checked)
            { 
                setValue('almocoQuarta', false);
                setValue('inicioExpedienteQuarta', '');
                setValue('fimExpedienteQuarta', '');
                setValue('inicioAlmocoQuarta',  '');
                setValue('fimAlmocoQuarta', '');
            }
        }
        else if(diaSemana === 4)//Quinta
        {
            setativaQuinta(e.target.checked);
            if(!e.target.checked)
            { 
                setValue('almocoQuinta', false);
                setValue('inicioExpedienteQuinta', '');
                setValue('fimExpedienteQuinta', '');
                setValue('inicioAlmocoQuinta',  '');
                setValue('fimAlmocoQuinta', '');
            }
        }
        else if(diaSemana === 5)//Sexta
        {
            setativaSexta(e.target.checked);
            if(!e.target.checked)
            { 
                setValue('almocoSexta', false);
                setValue('inicioExpedienteSexta', '');
                setValue('fimExpedienteSexta', '');
                setValue('inicioAlmocoSexta',  '');
                setValue('fimAlmocoSexta', '');
            }
        }
        else if(diaSemana === 6)//Sabado
        {
            setativaSabado(e.target.checked);
            if(!e.target.checked)
            { 
                setValue('almocoSabado', false);
                setValue('inicioExpedienteSabado', '');
                setValue('fimExpedienteSabado', '');
                setValue('inicioAlmocoSabado',  '');
                setValue('fimAlmocoSabado', '');
            }
        }
    }

    const handleAlmoco = (e,diaSemana) =>
    {
        clearError();
        if(diaSemana === 0)//Domingo
        {
            setalmocoDomingo(e.target.checked);
            if(!e.target.checked)
            { 
                setValue('inicioAlmocoDomingo',  '');
                setValue('fimAlmocoDomingo', '');
            }
        }
        else if(diaSemana === 1)//Segunda
        {
            setalmocoSegunda(e.target.checked);
            if(!e.target.checked)
            { 
                setValue('inicioAlmocoSegunda',  '');
                setValue('fimAlmocoSegunda', '');
            }
        }
        else if(diaSemana === 2)//Terca
        {
            setalmocoTerca(e.target.checked);
            if(!e.target.checked)
            { 
                setValue('inicioAlmocoTerca',  '');
                setValue('fimAlmocoTerca', '');
            }
        }
        else if(diaSemana === 3)//Quarta
        {
            setalmocoQuarta(e.target.checked);
            if(!e.target.checked)
            { 
                setValue('inicioAlmocoQuarta',  '');
                setValue('fimAlmocoQuarta', '');
            }
        }
        else if(diaSemana === 4)//Quinta
        {
            setalmocoQuinta(e.target.checked);
            if(!e.target.checked)
            { 
                setValue('inicioAlmocoQuinta',  '');
                setValue('fimAlmocoQuinta', '');
            }
        }
        else if(diaSemana === 5)//Sexta
        {
            setalmocoSexta(e.target.checked);
            if(!e.target.checked)
            { 
                setValue('inicioAlmocoSexta',  '');
                setValue('fimAlmocoSexta', '');
            }
        }
        else if(diaSemana === 6)//Sabado
        {
            setalmocoSabado(e.target.checked);
            if(!e.target.checked)
            { 
                setValue('inicioAlmocoSabado',  '');
                setValue('fimAlmocoSabado', '');
            }
        }
    }
    

    const horarios =[
        {horaValue:'00:00:00',hora:'00:00'},
        {horaValue:'00:30:00',hora:'00:30'},
        {horaValue:'01:00:00',hora:'01:00'},
        {horaValue:'01:30:00',hora:'01:30'},
        {horaValue:'02:00:00',hora:'02:00'},
        {horaValue:'02:30:00',hora:'02:30'},
        {horaValue:'03:00:00',hora:'03:00'},
        {horaValue:'03:30:00',hora:'03:30'},
        {horaValue:'04:00:00',hora:'04:00'},
        {horaValue:'04:30:00',hora:'04:30'},
        {horaValue:'05:00:00',hora:'05:00'},
        {horaValue:'05:30:00',hora:'05:30'},
        {horaValue:'06:00:00',hora:'06:00'},
        {horaValue:'06:30:00',hora:'06:30'},
        {horaValue:'07:00:00',hora:'07:00'},
        {horaValue:'07:30:00',hora:'07:30'},
        {horaValue:'08:00:00',hora:'08:00'},
        {horaValue:'08:30:00',hora:'08:30'},
        {horaValue:'09:00:00',hora:'09:00'},
        {horaValue:'09:30:00',hora:'09:30'},
        {horaValue:'10:00:00',hora:'10:00'},
        {horaValue:'10:30:00',hora:'10:30'},
        {horaValue:'11:00:00',hora:'11:00'},
        {horaValue:'11:30:00',hora:'11:30'},
        {horaValue:'12:00:00',hora:'12:00'},
        {horaValue:'12:30:00',hora:'12:30'},
        {horaValue:'13:00:00',hora:'13:00'},
        {horaValue:'13:30:00',hora:'13:30'},
        {horaValue:'14:00:00',hora:'14:00'},
        {horaValue:'14:30:00',hora:'14:30'},
        {horaValue:'15:00:00',hora:'15:00'},
        {horaValue:'15:30:00',hora:'15:30'},
        {horaValue:'16:00:00',hora:'16:00'},
        {horaValue:'16:30:00',hora:'16:30'},
        {horaValue:'17:00:00',hora:'17:00'},
        {horaValue:'17:30:00',hora:'17:30'},
        {horaValue:'18:00:00',hora:'18:00'},
        {horaValue:'18:30:00',hora:'18:30'},
        {horaValue:'19:00:00',hora:'19:00'},
        {horaValue:'19:30:00',hora:'19:30'},
        {horaValue:'20:00:00',hora:'20:00'},
        {horaValue:'20:30:00',hora:'20:30'},
        {horaValue:'21:00:00',hora:'21:00'},
        {horaValue:'21:30:00',hora:'21:30'},
        {horaValue:'22:00:00',hora:'22:00'},
        {horaValue:'22:30:00',hora:'22:30'},
        {horaValue:'23:00:00',hora:'23:00'},
        {horaValue:'23:30:00',hora:'23:30'}
    ]
    
    return (
        <div className="maxContent">              
            <form onSubmit={handleSubmit(onSubmit)}>
            <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                    <Card>
                        <CardHeader color="primary" icon>
                            <CardIcon color="primary">
                                <PermIdentity />
                            </CardIcon>
                            <h4 className={classes.cardIconTitle}>
                                {t('information_message.expedient_registration')} - <small>{t('information_message.fill_in_your_details')} </small>
                                <input className={classes.hidden} defaultValue={intialValues.id} name="id" ref={register} />
                            </h4>
                        </CardHeader>
                        <CardBody>                            
                            <GridContainer>
                                <GridItem xs={12} sm={6} md={8}> 
                                    <FormControl fullWidth className={classes.formControl}>                               
                                    <TextField                                        
                                        error={errors.descricao?true:false}
                                        label={t('label.description')+" *"}
                                        variant="outlined"
                                        inputRef={register({required: true})}
                                        name="descricao"
                                        defaultValue={intialValues.descricao}
                                        InputLabelProps={{shrink: true}}
                                        inputProps={{maxLength: 100}} 
                                    />
                                    <FormHelperText className={classes.labelRootError}>
                                        {errors.descricao && <span>{t('label.required')}</span>}
                                    </FormHelperText>   
                                    </FormControl>                                 
                                </GridItem>    
                                <GridItem xs={12} sm={12} md={4}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                tabIndex={-1}                                                
                                                checked={ativoCheckbox}   
                                                onClick={event => {setAtivoCheckbox(event.target.checked)}}                                             
                                                checkedIcon={<Check className={classes.checkedIcon} />}
                                                icon={<Check className={classes.uncheckedIcon} />}
                                                classes={{
                                                    checked: classes.checked,
                                                    root: classes.checkRoot
                                                }}                    
                                                name="ativo"  
                                                inputRef={register}                                                    
                                            />
                                        }
                                        classes={{
                                            label: classes.label,
                                            root: classes.labelRoot
                                        }}
                                        label={t('information_message.system_active')}
                                    />
                                </GridItem>
                            </GridContainer>
                            
                            <p>{t('information_message.note_setting_lunch_time_is_optional')} </p>

                            <div style={{overflowX: 'scroll'}} >
                                    <table className="table ">
                                        <thead>
                                            <tr>
                                            <th></th>
                                            <th width="12%" > <input type="checkbox" onChange={e => {handleAtiva(e,0)}} name="ativaDomingo" ref={register}/> <br/> {t('label.sunday')} </th>
                                            <th width="12%" > <input type="checkbox" onChange={e => {handleAtiva(e,1)}} name="ativaSegunda" ref={register}/> <br/> {t('label.monday')} </th>
                                            <th width="12%" > <input type="checkbox" onChange={e => {handleAtiva(e,2)}} name="ativaTerca" ref={register}/> <br/> {t('label.tuesday')} </th>
                                            <th width="12%" > <input type="checkbox" onChange={e => {handleAtiva(e,3)}} name="ativaQuarta" ref={register}/> <br/> {t('label.wednesday')} </th>
                                            <th width="12%" > <input type="checkbox" onChange={e => {handleAtiva(e,4)}} name="ativaQuinta" ref={register}/> <br/> {t('label.thursday')} </th>
                                            <th width="12%" > <input type="checkbox" onChange={e => {handleAtiva(e,5)}} name="ativaSexta" ref={register}/> <br/> {t('label.friday')} </th>
                                            <th width="12%" > <input type="checkbox" onChange={e => {handleAtiva(e,6)}} name="ativaSabado" ref={register}/> <br/> {t('label.saturday')} </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                            <td  >{t('register.start_of_expedient')} </td>
                                            <td>
                                                <select disabled={!ativaDomingo} name="inicioExpedienteDomingo" ref={register}>
                                                    <option value="">--</option>
                                                    {horarios.map(item => (   
                                                        <option key={item.hora} value={item.horaValue}>{item.hora}</option>
                                                    ))} 
                                                </select>                                               
                                                {errors.inicioExpedienteDomingo && <span className="obg">{t('label.required')}</span>}
                                            </td>
                                            <td>
                                                <select disabled={!ativaSegunda} name="inicioExpedienteSegunda" ref={register}>
                                                    <option value="">--</option>
                                                    {horarios.map(item => (   
                                                        <option key={item.hora} value={item.horaValue}>{item.hora}</option>
                                                    ))} 
                                                </select>                                               
                                                {errors.inicioExpedienteSegunda && <span className="obg">{t('label.required')}</span>}                                              
                                            </td>
                                            <td>
                                                <select disabled={!ativaTerca} name="inicioExpedienteTerca" ref={register}>
                                                    <option value="">--</option>
                                                    {horarios.map(item => (   
                                                        <option key={item.hora} value={item.horaValue}>{item.hora}</option>
                                                    ))} 
                                                </select>                                               
                                                {errors.inicioExpedienteTerca && <span className="obg">{t('label.required')}</span>}                                              
                                            </td>
                                            <td>
                                                <select disabled={!ativaQuarta} name="inicioExpedienteQuarta" ref={register}>
                                                    <option value="">--</option>
                                                    {horarios.map(item => (   
                                                        <option key={item.hora} value={item.horaValue}>{item.hora}</option>
                                                    ))} 
                                                </select>                                               
                                                {errors.inicioExpedienteQuarta && <span className="obg">{t('label.required')}</span>}                                                
                                            </td>
                                            <td>
                                                <select disabled={!ativaQuinta} name="inicioExpedienteQuinta" ref={register}>
                                                    <option value="">--</option>
                                                    {horarios.map(item => (   
                                                        <option key={item.hora} value={item.horaValue}>{item.hora}</option>
                                                    ))} 
                                                </select>                                               
                                                {errors.inicioExpedienteQuinta && <span className="obg">{t('label.required')}</span>}                                              
                                            </td>
                                            <td>
                                                <select disabled={!ativaSexta} name="inicioExpedienteSexta" ref={register}>
                                                    <option value="">--</option>
                                                    {horarios.map(item => (   
                                                        <option key={item.hora} value={item.horaValue}>{item.hora}</option>
                                                    ))} 
                                                </select>                                               
                                                {errors.inicioExpedienteSexta && <span className="obg">{t('label.required')}</span>}
                                            </td>
                                            <td>
                                                <select disabled={!ativaSabado} name="inicioExpedienteSabado" ref={register}>
                                                    <option value="">--</option>
                                                    {horarios.map(item => (   
                                                        <option key={item.hora} value={item.horaValue}>{item.hora}</option>
                                                    ))} 
                                                </select>                                               
                                                {errors.inicioExpedienteSabado && <span className="obg">{t('label.required')}</span>}
                                            </td>
                                            </tr>
                                            <tr>
                                            <td  >{t('register.end_of_expedient')} </td>
                                            <td>
                                                <select disabled={!ativaDomingo} name="fimExpedienteDomingo" ref={register}>
                                                    <option value="">--</option>
                                                    {horarios.map(item => (   
                                                        <option key={item.hora} value={item.horaValue}>{item.hora}</option>
                                                    ))} 
                                                </select>                                               
                                                {errors.fimExpedienteDomingo && <span className="obg">{t('label.required')}</span>}
                                            </td>
                                            <td>
                                                <select disabled={!ativaSegunda} name="fimExpedienteSegunda" ref={register}>
                                                    <option value="">--</option>
                                                    {horarios.map(item => (   
                                                        <option key={item.hora} value={item.horaValue}>{item.hora}</option>
                                                    ))} 
                                                </select>                                               
                                                {errors.fimExpedienteSegunda && <span className="obg">{t('label.required')}</span>}
                                            </td>
                                            <td>
                                                <select disabled={!ativaTerca} name="fimExpedienteTerca" ref={register}>
                                                    <option value="">--</option>
                                                    {horarios.map(item => (   
                                                        <option key={item.hora} value={item.horaValue}>{item.hora}</option>
                                                    ))} 
                                                </select>                                               
                                                {errors.fimExpedienteTerca && <span className="obg">{t('label.required')}</span>}
                                            </td>
                                            <td>
                                                <select disabled={!ativaQuarta} name="fimExpedienteQuarta" ref={register}>
                                                    <option value="">--</option>
                                                    {horarios.map(item => (   
                                                        <option key={item.hora} value={item.horaValue}>{item.hora}</option>
                                                    ))} 
                                                </select>                                               
                                                {errors.fimExpedienteQuarta && <span className="obg">{t('label.required')}</span>}
                                            </td>
                                            <td>
                                                <select disabled={!ativaQuinta} name="fimExpedienteQuinta" ref={register}>
                                                    <option value="">--</option>
                                                    {horarios.map(item => (   
                                                        <option key={item.hora} value={item.horaValue}>{item.hora}</option>
                                                    ))} 
                                                </select>                                               
                                                {errors.fimExpedienteQuinta && <span className="obg">{t('label.required')}</span>}
                                            </td>
                                            <td>
                                                <select disabled={!ativaSexta} name="fimExpedienteSexta" ref={register}>
                                                    <option value="">--</option>
                                                    {horarios.map(item => (   
                                                        <option key={item.hora} value={item.horaValue}>{item.hora}</option>
                                                    ))} 
                                                </select>                                               
                                                {errors.fimExpedienteSexta && <span className="obg">{t('label.required')}</span>}
                                            </td>
                                            <td>
                                                <select disabled={!ativaSabado} name="fimExpedienteSabado" ref={register}>
                                                    <option value="">--</option>
                                                    {horarios.map(item => (   
                                                        <option key={item.hora} value={item.horaValue}>{item.hora}</option>
                                                    ))} 
                                                </select>                                               
                                                {errors.fimExpedienteSabado && <span className="obg">{t('label.required')}</span>}
                                            </td>
                                            </tr>
                                            <tr>
                                                <td>{t('register.lunch_break')} </td>
                                                <td> <input disabled={!ativaDomingo} onChange={e => {handleAlmoco(e,0)}} type="checkbox" name="almocoDomingo" ref={register}/> <br/> {t('label.yes')} </td>
                                                <td> <input disabled={!ativaSegunda} onChange={e => {handleAlmoco(e,1)}} type="checkbox" name="almocoSegunda" ref={register}/> <br/> {t('label.yes')} </td>
                                                <td> <input disabled={!ativaTerca}   onChange={e => {handleAlmoco(e,2)}} type="checkbox" name="almocoTerca" ref={register}/> <br/> {t('label.yes')} </td>
                                                <td> <input disabled={!ativaQuarta}  onChange={e => {handleAlmoco(e,3)}} type="checkbox" name="almocoQuarta" ref={register}/> <br/> {t('label.yes')} </td>
                                                <td> <input disabled={!ativaQuinta}  onChange={e => {handleAlmoco(e,4)}} type="checkbox" name="almocoQuinta" ref={register}/> <br/> {t('label.yes')} </td>
                                                <td> <input disabled={!ativaSexta}   onChange={e => {handleAlmoco(e,5)}} type="checkbox" name="almocoSexta" ref={register}/> <br/> {t('label.yes')} </td>
                                                <td> <input disabled={!ativaSabado}  onChange={e => {handleAlmoco(e,6)}} type="checkbox" name="almocoSabado" ref={register}/> <br/> {t('label.yes')} </td>
                                            </tr>
                                            <tr>
                                            <td  >{t('register.start_of_lunch')}</td>
                                            <td>                                                
                                                <select disabled={!ativaDomingo || !almocoDomingo} name="inicioAlmocoDomingo" ref={register}>
                                                    <option value="">--</option>
                                                    {horarios.map(item => (   
                                                        <option key={item.hora} value={item.horaValue}>{item.hora}</option>
                                                    ))} 
                                                </select>                                               
                                                {errors.inicioAlmocoDomingo && <span className="obg">{t('label.required')}</span>}
                                            </td>
                                            <td>                                                
                                                <select disabled={!ativaSegunda || !almocoSegunda} name="inicioAlmocoSegunda" ref={register}>
                                                    <option value="">--</option>
                                                    {horarios.map(item => (   
                                                        <option key={item.hora} value={item.horaValue}>{item.hora}</option>
                                                    ))} 
                                                </select>                                               
                                                {errors.inicioAlmocoSegunda && <span className="obg">{t('label.required')}</span>}
                                            </td>
                                            <td>                                                
                                                <select disabled={!ativaTerca || !almocoTerca} name="inicioAlmocoTerca" ref={register}>
                                                    <option value="">--</option>
                                                    {horarios.map(item => (   
                                                        <option key={item.hora} value={item.horaValue}>{item.hora}</option>
                                                    ))} 
                                                </select>                                               
                                                {errors.inicioAlmocoTerca && <span className="obg">{t('label.required')}</span>}
                                            </td>
                                            <td>                                                
                                                <select disabled={!ativaQuarta || !almocoQuarta} name="inicioAlmocoQuarta" ref={register}>
                                                    <option value="">--</option>
                                                    {horarios.map(item => (   
                                                        <option key={item.hora} value={item.horaValue}>{item.hora}</option>
                                                    ))} 
                                                </select>                                               
                                                {errors.inicioAlmocoQuarta && <span className="obg">{t('label.required')}</span>}
                                            </td>
                                            <td>                                                
                                                <select disabled={!ativaQuinta || !almocoQuinta} name="inicioAlmocoQuinta" ref={register}>
                                                    <option value="">--</option>
                                                    {horarios.map(item => (   
                                                        <option key={item.hora} value={item.horaValue}>{item.hora}</option>
                                                    ))} 
                                                </select>                                               
                                                {errors.inicioAlmocoQuinta && <span className="obg">{t('label.required')}</span>}
                                            </td>
                                            <td>                                                
                                                <select disabled={!ativaSexta || !almocoSexta} name="inicioAlmocoSexta" ref={register}>
                                                    <option value="">--</option>
                                                    {horarios.map(item => (   
                                                        <option key={item.hora} value={item.horaValue}>{item.hora}</option>
                                                    ))} 
                                                </select>                                               
                                                {errors.inicioAlmocoSexta && <span className="obg">{t('label.required')}</span>}
                                            </td>
                                            <td>                                                
                                                <select disabled={!ativaSabado || !almocoSabado} name="inicioAlmocoSabado" ref={register}>
                                                    <option value="">--</option>
                                                    {horarios.map(item => (   
                                                        <option key={item.hora} value={item.horaValue}>{item.hora}</option>
                                                    ))} 
                                                </select>                                               
                                                {errors.inicioAlmocoSabado && <span className="obg">{t('label.required')}</span>}
                                            </td>
                                            </tr>
                                            <tr>
                                            <td>{t('register.end_of_lunch')}</td>
                                            <td>                                                
                                                <select disabled={!ativaDomingo || !almocoDomingo} name="fimAlmocoDomingo" ref={register}>
                                                    <option value="">--</option>
                                                    {horarios.map(item => (   
                                                        <option key={item.hora} value={item.horaValue}>{item.hora}</option>
                                                    ))} 
                                                </select>                                               
                                                {errors.fimAlmocoDomingo && <span className="obg">{t('label.required')}</span>}
                                            </td>
                                            <td>                                                
                                                <select disabled={!ativaSegunda || !almocoSegunda} name="fimAlmocoSegunda" ref={register}>
                                                    <option value="">--</option>
                                                    {horarios.map(item => (   
                                                        <option key={item.hora} value={item.horaValue}>{item.hora}</option>
                                                    ))} 
                                                </select>                                               
                                                {errors.fimAlmocoSegunda && <span className="obg">{t('label.required')}</span>}
                                            </td>
                                            <td>                                                
                                                <select disabled={!ativaTerca || !almocoTerca} name="fimAlmocoTerca" ref={register}>
                                                    <option value="">--</option>
                                                    {horarios.map(item => (   
                                                        <option key={item.hora} value={item.horaValue}>{item.hora}</option>
                                                    ))} 
                                                </select>                                               
                                                {errors.fimAlmocoTerca && <span className="obg">{t('label.required')}</span>}
                                            </td>
                                            <td>                                                
                                                <select disabled={!ativaQuarta || !almocoQuarta} name="fimAlmocoQuarta" ref={register}>
                                                    <option value="">--</option>
                                                    {horarios.map(item => (   
                                                        <option key={item.hora} value={item.horaValue}>{item.hora}</option>
                                                    ))} 
                                                </select>                                               
                                                {errors.fimAlmocoQuarta && <span className="obg">{t('label.required')}</span>}
                                            </td>
                                            <td>                                                
                                                <select disabled={!ativaQuinta || !almocoQuinta} name="fimAlmocoQuinta" ref={register}>
                                                    <option value="">--</option>
                                                    {horarios.map(item => (   
                                                        <option key={item.hora} value={item.horaValue}>{item.hora}</option>
                                                    ))} 
                                                </select>                                               
                                                {errors.fimAlmocoQuinta && <span className="obg">{t('label.required')}</span>}
                                            </td>
                                            <td>                                                
                                                <select disabled={!ativaSexta || !almocoSexta} name="fimAlmocoSexta" ref={register}>
                                                    <option value="">--</option>
                                                    {horarios.map(item => (   
                                                        <option key={item.hora} value={item.horaValue}>{item.hora}</option>
                                                    ))} 
                                                </select>                                               
                                                {errors.fimAlmocoSexta && <span className="obg">{t('label.required')}</span>}
                                            </td>
                                            <td>                                                
                                                <select disabled={!ativaSabado || !almocoSabado} name="fimAlmocoSabado" ref={register}>
                                                    <option value="">--</option>
                                                    {horarios.map(item => (   
                                                        <option key={item.hora} value={item.horaValue}>{item.hora}</option>
                                                    ))} 
                                                </select>                                               
                                                {errors.fimAlmocoSabado && <span className="obg">{t('label.required')}</span>}
                                            </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>       
                            <GridContainer>

                            </GridContainer>
                            <Clearfix />
                        </CardBody>
                    </Card>
                </GridItem>
            </GridContainer>
            <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={12} className={classes.textCenter}>
                    <div className={classes.textCenter}>
                        <Button  onClick={() => handleViewForm()} color="transparent" className={classes.updateProfileButton}>
                            {t('button.cancel')}
                        </Button>
                        <Button type="submit" color="primary" className={classes.updateProfileButton}>
                            {t('button.to_save')} 
                            {loading && <div> ...{t('label.loading')}</div>}
                        </Button>
                    </div>
                </GridItem>
            </GridContainer>            
            </form>
        </div>
    );
}